import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "sidebar-menu" }
const _hoisted_4 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_5 = { class: "sidebar-nav-item" }
const _hoisted_6 = {
  key: 0,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_7 = {
  id: "sidebarCollapseColis",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_8 = { class: "accordion-body" }
const _hoisted_9 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_10 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_11 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_12 = {
  key: 2,
  class: "sidebar-sub-menu-item"
}
const _hoisted_13 = {
  key: 3,
  class: "sidebar-sub-menu-item"
}
const _hoisted_14 = {
  key: 1,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_15 = {
  id: "sidebarCollapseStock",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_16 = { class: "accordion-body" }
const _hoisted_17 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_18 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_19 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_20 = {
  key: 2,
  class: "sidebar-sub-menu-item"
}
const _hoisted_21 = {
  key: 3,
  class: "sidebar-sub-menu-item"
}
const _hoisted_22 = {
  key: 2,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_23 = {
  id: "sidebarCollapseBl",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_24 = { class: "accordion-body" }
const _hoisted_25 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_26 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_27 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_28 = {
  key: 3,
  class: "sidebar-nav-item"
}
const _hoisted_29 = {
  key: 4,
  class: "sidebar-nav-item"
}
const _hoisted_30 = {
  key: 5,
  class: "sidebar-nav-item"
}
const _hoisted_31 = {
  key: 6,
  class: "sidebar-nav-item"
}
const _hoisted_32 = {
  key: 7,
  class: "sidebar-nav-item"
}
const _hoisted_33 = {
  key: 8,
  class: "sidebar-nav-item"
}
const _hoisted_34 = {
  key: 9,
  class: "sidebar-nav-item"
}
const _hoisted_35 = {
  key: 10,
  class: "sidebar-nav-item"
}
const _hoisted_36 = {
  key: 11,
  class: "sidebar-nav-item"
}
const _hoisted_37 = { class: "sidebar-nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.settingsStore.logo || require('../../assets/images/logo.png'),
            style: {"width":"80%","max-height":"44px","object-fit":"fill"}
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "border-bottom" }, null, -1)),
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
      ]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "flaticon-more-1" }, null, -1),
              _createElementVNode("span", { class: "title" }, "Dashboard", -1)
            ])),
            _: 1,
            __: [3]
          })
        ]),
        (_ctx.canAny('/add-colis', '/colis-list', '/new-colis-list', '/import-colis'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
              _cache[8] || (_cache[8] = _createElementVNode("a", {
                href: "#",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#sidebarCollapseColis",
                "aria-expanded": "false",
                "aria-controls": "sidebarCollapseColis"
              }, [
                _createElementVNode("i", { class: "flaticon-sterile-box" }),
                _createElementVNode("span", { class: "title" }, "Colis")
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("ul", _hoisted_9, [
                    (_ctx.canRoute('/add-colis'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                          _createVNode(_component_router_link, {
                            to: "/add-colis",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode(" Nouveau colis ", -1)
                            ])),
                            _: 1,
                            __: [4]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canRoute('/colis-list'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                          _createVNode(_component_router_link, {
                            to: "/colis-list",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode(" Liste des colis ", -1)
                            ])),
                            _: 1,
                            __: [5]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canRoute('/new-colis-list'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                          _createVNode(_component_router_link, {
                            to: "/new-colis-list",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createTextVNode(" Colis pour ramassage ", -1)
                            ])),
                            _: 1,
                            __: [6]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canRoute('/import-colis'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                          _createVNode(_component_router_link, {
                            to: "/import-colis",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode(" Importation colis ", -1)
                            ])),
                            _: 1,
                            __: [7]
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.canAny('/products-list', '/colis-stock-list', '/add-colis-stock', '/import-colis-stock'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
              _cache[13] || (_cache[13] = _createElementVNode("a", {
                href: "#",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#sidebarCollapseStock",
                "aria-expanded": "false",
                "aria-controls": "sidebarCollapseStock"
              }, [
                _createElementVNode("i", { class: "flaticon-sterile-box" }),
                _createElementVNode("span", { class: "title" }, "Inventaire")
              ], -1)),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("ul", _hoisted_17, [
                    (_ctx.canRoute('/products-list'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                          _createVNode(_component_router_link, {
                            to: "/products-list",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode(" Liste des produits ", -1)
                            ])),
                            _: 1,
                            __: [9]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canRoute('/colis-stock-list'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                          _createVNode(_component_router_link, {
                            to: "/colis-stock-list",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createTextVNode(" Colis de stock ", -1)
                            ])),
                            _: 1,
                            __: [10]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canRoute('/add-colis-stock'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                          _createVNode(_component_router_link, {
                            to: "/add-colis-stock",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode(" Nouveau colis ", -1)
                            ])),
                            _: 1,
                            __: [11]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canRoute('/import-colis-stock'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                          _createVNode(_component_router_link, {
                            to: "/import-colis-stock",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode(" Importation colis ", -1)
                            ])),
                            _: 1,
                            __: [12]
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.canAny('/delivery-notes', '/add-delivery-note'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
              _cache[16] || (_cache[16] = _createElementVNode("a", {
                href: "#",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#sidebarCollapseBl",
                "aria-expanded": "false",
                "aria-controls": "sidebarCollapseBl"
              }, [
                _createElementVNode("i", { class: "flaticon-document" }),
                _createElementVNode("span", { class: "title" }, "Bons de livraison")
              ], -1)),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("ul", _hoisted_25, [
                    (_ctx.canRoute('/delivery-notes'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                          _createVNode(_component_router_link, {
                            to: "/delivery-notes",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode(" Bons de livraison ", -1)
                            ])),
                            _: 1,
                            __: [14]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canRoute('/add-delivery-note'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                          _createVNode(_component_router_link, {
                            to: "/add-delivery-note",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode(" Nouveau Bon de livraison ", -1)
                            ])),
                            _: 1,
                            __: [15]
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.canRoute('/invoices-liste'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
              _createVNode(_component_router_link, {
                to: "/invoices-liste",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createElementVNode("i", { class: "flaticon-money" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Mes factures", -1)
                ])),
                _: 1,
                __: [17]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.canRoute('/return-client-liste'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
              _createVNode(_component_router_link, {
                to: "/return-client-liste",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createElementVNode("i", { class: "flaticon-project" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Bons de retour", -1)
                ])),
                _: 1,
                __: [18]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.canRoute('/claims-list'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
              _createVNode(_component_router_link, {
                to: "/claims-list",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createElementVNode("i", { class: "flaticon-warning" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Réclamations", -1)
                ])),
                _: 1,
                __: [19]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.canRoute('/requests-pickup-list'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
              _createVNode(_component_router_link, {
                to: "/requests-pickup-list",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createElementVNode("i", { class: "flaticon-ticket" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Ramassage", -1)
                ])),
                _: 1,
                __: [20]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.canRoute('/users-list'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
              _createVNode(_component_router_link, {
                to: "/users-list",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [
                  _createElementVNode("i", { class: "flaticon-user-3" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Utilisateurs", -1)
                ])),
                _: 1,
                __: [21]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.canRoute('/black-list'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
              _createVNode(_component_router_link, {
                to: "/black-list",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createElementVNode("i", { class: "flaticon-warning" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Black liste", -1)
                ])),
                _: 1,
                __: [22]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.canRoute('/documentation-api'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
              _createVNode(_component_router_link, {
                to: "/documentation-api",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "flaticon-settings" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Documentation API", -1)
                ])),
                _: 1,
                __: [23]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.canRoute('/documents'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
              _createVNode(_component_router_link, {
                to: "/documents",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [
                  _createElementVNode("i", { class: "flaticon-document" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Mes documents", -1)
                ])),
                _: 1,
                __: [24]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.canRoute('/webhooks'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
              _createVNode(_component_router_link, {
                to: "/webhooks",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [
                  _createElementVNode("i", { class: "flaticon-notification" }, null, -1),
                  _createElementVNode("span", { class: "title" }, "Webhooks", -1)
                ])),
                _: 1,
                __: [25]
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_37, [
          _createVNode(_component_router_link, {
            to: "/account-settings",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [
              _createElementVNode("i", { class: "flaticon-user" }, null, -1),
              _createElementVNode("span", { class: "title" }, "Profile", -1)
            ])),
            _: 1,
            __: [26]
          })
        ])
      ])
    ])
  ], 2))
}